<template>
  <div>
    <template v-for="section in sections.filter(Boolean)">
      <lazy-hydrate
        :key="section.id"
        if="section.componentType"
        when-visible
      >
        <component
          :is="section.componentType"
          v-bind="section"
        >
          <div
            v-for="(slotName, fieldName, slotIndex) in getSlots(section)"
            :slot="slotName"
            :key="slotName + slotIndex"
          >
            <rich-text
              v-if="section[fieldName]"
              :body="section[fieldName]"
            />
          </div>
          <div
            v-if="section.aside"
            slot="aside"
          >
            <aside-component :component="section.aside" />
          </div>
        </component>
      </lazy-hydrate>
    </template>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'
import { getComponentSlots } from '../'
import AsideComponent from './AsideComponent.vue'
import FragmentComponent from './FragmentComponent.vue'
import RichText from './RichText.vue'

export default {
  name: 'PageSections',
  components: {
    AsideComponent,
    FragmentComponent,
    LazyHydrate,
    RichText,
    ZgArticlePreviewSection: () =>
      import('@zc/components/sections/ZgArticlePreviewSection/ZgArticlePreviewSection'),
    ZgCard: () =>
      import('@zc/components/ZgCard/ZgCard'),
    ZgCardSection: () =>
      import('@zc/components/sections/ZgCardSection/ZgCardSection'),
    ZgChipsListSection: () =>
      import('@zc/components/sections/ZgChipsListSection/ZgChipsListSection'),
    ZgCrossSellSection: () =>
      import('@zc/components/sections/ZgCrossSellSection/ZgCrossSellSection'),
    ZgFaqSection: () =>
      import('@zc/components/sections/ZgFaqSection/ZgFaqSection'),
    ZgItemSection: () =>
      import('@zc/components/sections/ZgItemSection/ZgItemSection'),
    ZgJumpLinkSection: () =>
      import('@zc/components/sections/ZgJumpLinkSection/ZgJumpLinkSection'),
    ZgPageLinkSection: () =>
      import('@zc/components/sections/ZgPageLinkSection/ZgPageLinkSection'),
    ZgLogoCardSection: () =>
      import('@zc/components/sections/ZgLogoCardSection/ZgLogoCardSection'),
    ZgTeaserSection: () =>
      import('@zc/components/sections/ZgTeaserSection/ZgTeaserSection'),
    ZgTestimonialSection: () =>
      import('@zc/components/sections/ZgTestimonialSection/ZgTestimonialSection'),
    ZgTextSection: () =>
      import('@zc/components/sections/ZgTextSection/ZgTextSection'),
    ZgTipsSection: () =>
      import('@zc/components/sections/ZgTipsSection/ZgTipsSection'),
    ZgVideoSection: () =>
      import('@zc/components/sections/ZgVideoSection/ZgVideoSection'),
    ZgHighlightedPartners: () =>
      import('@zc/components/ZgHighlightedPartners/ZgHighlightedPartners'),
    ZgCrossSellItemSection: () =>
      import('@zc/components/sections/ZgCrossSellItemSection/ZgCrossSellItemSection'),
    ZgLinkListSection: () =>
      import('@zc/components/sections/ZgLinkListSection/ZgLinkListSection'),
    ZgReviewedBySection: () =>
      import('@zc/components/sections/ZgReviewedBySection/ZgReviewedBySection'),
    ZgQuotedBySection: () =>
      import('@zc/components/sections/ZgQuotedBySection/ZgQuotedBySection')
  },
  props: {
    sections: {
      type: Array,
      default: () => []
    }
  },
  created () {
    this.sections.forEach((section) => {
      if (section.componentRef) {
        section.componentType = `custom-${section.componentRef.replace(
            /[/_]/g,
            '-'
          )}`

        this.$options.components[section.componentType] = () => {
          try {
            return import(`@customComponents/${section.componentRef}.vue`)
          } catch {}
        }
      }
    })
  },
  methods: {
    getSlots: (section) => getComponentSlots(section)
  }
}
</script>
